import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserTypes, OrgTypes } from '@mode/shared/contract-common';
import { DialogService } from '@mode/shared/ui';
import { ContextDialogComponent } from './context-dialog.component';

@Injectable()
export class ContextDialogService {
  readonly MODAL_ID = 'mode-context-dialog-modal';
  readonly MODAL_MAX_HEIGHT = 496;

  constructor(private dialogService: DialogService) {}

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS7060
  open({
    currentUser,
    currentOrg,
    disableClose = false,
    connectDatabaseElementId,
    userOrgs$,
    isUserOrgsLoading$,
    isUserOrgsComplete$,
    hasMemberOrgs$,
  }: {
    currentUser: UserTypes.User | undefined;
    currentOrg: OrgTypes.Organization | undefined;
    disableClose?: boolean;
    connectDatabaseElementId?: string;
    userOrgs$: Observable<ReadonlyArray<UserTypes.UserOrganization>>;
    isUserOrgsLoading$: Observable<boolean>;
    isUserOrgsComplete$: Observable<boolean>;
    hasMemberOrgs$: Observable<boolean>;
  }) {
    const dialogExists = this.dialogService.getDialogById(this.MODAL_ID);
    if (!dialogExists) {
      return this.dialogService
        .open({
          component: ContextDialogComponent,
          matDialogConfig: {
            id: this.MODAL_ID,
            maxHeight: `${this.MODAL_MAX_HEIGHT}px`,
            data: {
              currentUser,
              currentOrg,
              userOrgs$,
              isUserOrgsLoading$,
              isUserOrgsComplete$,
              hasMemberOrgs$,
              connectDatabaseElementId,
            },
            disableClose,
          },
        })
        .afterClosed();
    }
  }
}
